import Header from "../components/Header";
import Footer from "../components/Footer";
import Sidebar from "../components/Sidebar";
import { Helmet } from "react-helmet";

export default function PremiumOneToOne() {
  return (
    <>
      <Helmet>
        <title>
          1-to-1 Public Speaking Coaching for Adults & Kids | Public Speaking
          Academy
        </title>
        <meta
          name="description"
          content="We Offer Premium 1-to-1 Training to Coach Effective Communication Skills. Contact Us Today For a Public Speaking Coach or Corporate Training!"
        ></meta>
      </Helmet>

      <section id="breadcrumb" className="bg-[#F5F5FC] py-1">
        <div className="container mx-auto">
          <div className="flex flex-row justify-between mx-3">
            <div>CUSTOMISED 1-TO-1 PRIVATE TRAINING</div>
            <div>Home / Courses & Programs / Premium 1-to-1</div>
          </div>
        </div>
      </section>

      <section id="block-1" className="mx-3">
        <div class="container mx-auto py-20">
          <div class="flex flex-col lg:flex-row pt-5 space-x-10">
            <div class="w-full lg:w-2/3">
              <h1 class="font-primary text-3xl font-bold text-primary uppercase">
                Premium One-to-One Public Speaking Training (for Kids, Adults or
                Corporate Clients)
              </h1>
              <h2 class="font-primary text-2xl font-bold text-primary uppercase py-5">
                Customised Training for your Learning Needs
              </h2>
              <div>
                <p class="pb-5">
                  The Public Speaking Academy has an extensive record of
                  providing customised public speaking training for clients of
                  all ages, background and learning needs. Since 2009, our team
                  of professional and highly qualified public speaking trainers
                  have trained and coached clients (on a one-to-one basis), with
                  learning plans tailored to meet our clients’ diverse learning
                  objectives. Through the premium one-to-one public speaking
                  training, our clients enjoy unparalleled privacy,
                  individualised attention and rigorous development from our
                  professional trainers
                </p>
                <p class="pb-5">
                  So far, we have trained clients from as young as 7 years old,
                  to prepare for national public speaking competitions, to
                  corporate executives / senior management professionals,
                  looking to improve their business presentations skills (both
                  Singapore and abroad). For that customised and dedicated
                  approach to learning, we welcome you to reach out to us to
                  discuss your unique public speaking learning journey!
                </p>
                <p class="pb-5">
                  <strong>
                    Our Customised Public Speaking Learning Journey
                  </strong>
                </p>
                <p class="pb-5">
                  In preparing our customised public speaking learning journey
                  for you, the Public Speaking Academy draws upon on our
                  extensive experience, professional training team and our
                  established syllabus (as registered with the Ministry of
                  Education). Beyond this, our premium one-to-one public
                  speaking training also offers our clients the wide flexibility
                  of selecting their learning objectives, preferred timing/venue
                  or their pick from our professional trainers with their
                  diverse background. We provide value to our one-to-one clients
                  through:
                </p>
                <ul className="p-5 list-disc list-outside">
                  <li className="pb-5 text-lg font-text">
                    <strong>
                      Designing a Structured & Customised Solution
                    </strong>{" "}
                    – we believe in engaging with our one-to-one clients first
                    to understand their specific learning objectives and how
                    best to design and structure the best-fit public speaking
                    training programme
                  </li>
                  <li className="pb-5 text-lg font-text">
                    <strong>Communications Skills Sharing & Practice</strong> –
                    we draw upon our experience and expertise in presenting a
                    suite of effective communication skills and techniques,
                    through demonstration and practise with our professional
                    trainers
                  </li>
                  <li className="pb-5 text-lg font-text">
                    <strong>
                      Rigorous, but Safe Platform for Public Speaking Practice
                    </strong>{" "}
                    – we provide our clients with a challenging, but safe,
                    platform to practise – be it a high-impact business
                    presentation or rehearsing for a national public speaking
                    competition
                  </li>
                  <li className="pb-5 text-lg font-text">
                    <strong>
                      Immediate, Constructive and Targeted Feedback
                    </strong>{" "}
                    – we provide immediate, constructive and targeted feedback
                    for each session for a thorough and focused growth in their
                    public speaking abilities
                  </li>
                </ul>

                <p class="pb-5">
                  Our one-to-one clients have approached us for a variety of
                  public speaking and coaching services, including:
                </p>
                <div className="flex flex-row my-10">
                  <div className="w-1/2">
                    <div className="flex flex-row items-center my-3">
                      <div>
                        <span class="material-symbols-rounded bg-orange-600 text-white p-2 rounded-full">
                          group
                        </span>
                      </div>
                      <div className="ml-4 font-bold">Seminar Talks</div>
                    </div>

                    <div className="flex flex-row items-center my-3">
                      <div>
                        <span class="material-symbols-rounded bg-orange-600 text-white p-2 rounded-full">
                          emoji_people
                        </span>
                      </div>
                      <div className="ml-4 font-bold">
                        High-stakes business presentations
                      </div>
                    </div>

                    <div className="flex flex-row items-center my-3">
                      <div>
                        <span class="material-symbols-rounded bg-orange-600 text-white p-2 rounded-full">
                          psychology
                        </span>
                      </div>
                      <div className="ml-4 font-bold">Workshop speeches</div>
                    </div>

                    <div className="flex flex-row items-center my-3">
                      <div>
                        <span class="material-symbols-rounded bg-orange-600 text-white p-2 rounded-full">
                          diamond
                        </span>
                      </div>
                      <div className="ml-4 font-bold">Wedding toasts</div>
                    </div>

                    <div className="flex flex-row items-center my-3">
                      <div>
                        <span class="material-symbols-rounded bg-orange-600 text-white p-2 rounded-full">
                          clinical_notes
                        </span>
                      </div>
                      <div className="ml-4 font-bold">Keynote addresses</div>
                    </div>
                  </div>
                  <div className="w-1/2">
                    <div className="flex flex-row items-center my-3">
                      <div>
                        <span class="material-symbols-rounded bg-orange-600 text-white p-2 rounded-full">
                          lab_research
                        </span>
                      </div>
                      <div className="ml-4 font-bold">
                        Speech contest preparations
                      </div>
                    </div>

                    <div className="flex flex-row items-center my-3">
                      <div>
                        <span class="material-symbols-rounded bg-orange-600 text-white p-2 rounded-full">
                          trending_up
                        </span>
                      </div>
                      <div className="ml-4 font-bold">Pitches</div>
                    </div>

                    <div className="flex flex-row items-center my-3">
                      <div>
                        <span class="material-symbols-rounded bg-orange-600 text-white p-2 rounded-full">
                          insert_chart
                        </span>
                      </div>
                      <div className="ml-4 font-bold">Board presentations</div>
                    </div>

                    <div className="flex flex-row items-center my-3">
                      <div>
                        <span class="material-symbols-rounded bg-orange-600 text-white p-2 rounded-full">
                          diversity_2
                        </span>
                      </div>
                      <div className="ml-4 font-bold">
                        Interpersonal communication scenarios
                      </div>
                    </div>

                    <div className="flex flex-row items-center my-3">
                      <div>
                        <span class="material-symbols-rounded bg-orange-600 text-white p-2 rounded-full">
                          diversity_3
                        </span>
                      </div>
                      <div className="ml-4 font-bold">
                        General development (in the area of effective
                        communication)
                      </div>
                    </div>
                  </div>
                </div>
                <p class="pb-5">
                  Whether you are looking for focused feedback for a high-stakes
                  business presentation or preparing for a speech before a large
                  audience, our premium one-to-one public speaking training is
                  perfect for you! Our pricing scaffold is likewise transparent
                  and reasonable – as we would need to customise the public
                  speaking training programme to match your learning needs, we
                  welcome you to reach out to us for a discussion and a
                  quotation!
                  <br />
                  The Public Speaking Academy looks forward to being there
                  through every step of your public speaking and
                  confidence-building journey!
                </p>

                <div className="bg-slate-50 p-2 md:p-10 ">
                  <div className=" mb-10">
                    <h1 className="divider text-primary font-primary font-bold uppercase text-2xl md:text-3xl">
                      END OF COURSE DETAILS
                    </h1>
                    <h1 className="text-slate-500 font-primary font-bold text-center text-xl md:text-2xl">
                      Quick Tips
                    </h1>
                  </div>

                  <div
                    tabIndex={0}
                    className="border collapse collapse-arrow border-gray-200 rounded-box bg-white"
                  >
                    <div className="text-xl font-medium collapse-title text-btnColor">
                      🧭 Is Public Speaking a Leadership Skill?
                    </div>
                    <div className="collapse-content">
                      <p className="p-1">
                        Yes — <b>public speaking is a core leadership skill</b>.
                        Leaders need to inform, inspire, and influence
                        others—and strong speaking skills help make that happen.
                      </p>
                      <p className="py-1">Here’s why it matters:</p>
                      <div className="py-1">
                        <p className="font-bold font-primary">
                          1. Builds trust and credibility
                        </p>
                        <p className="font-bold font-text">
                          Clear, confident speech helps leaders earn respect and
                          command attention.
                        </p>
                      </div>
                      <div className="py-1">
                        <p className="font-bold font-primary">
                          2. Clarifies vision and direction
                        </p>
                        <p className="font-bold font-text">
                          Great leaders communicate goals and values in a way
                          that rallies others to act.
                        </p>
                      </div>
                      <div className="py-1">
                        <p className="font-bold font-primary">
                          3. Inspires and motivates
                        </p>
                        <p className="font-bold font-text">
                          Storytelling, tone, and presence can ignite team
                          morale and momentum.
                        </p>
                      </div>
                      <div className="py-1">
                        <p className="font-bold font-primary">
                          4. Navigates tough conversations
                        </p>
                        <p className="font-bold font-text">
                          Whether it’s delivering feedback or handling crisis,
                          effective speaking keeps people aligned.
                        </p>
                      </div>
                      <div className="py-1">
                        <p className="font-bold font-primary">
                          5. Boosts influence and visibility
                        </p>
                        <p className="font-bold font-text">
                          The ability to speak well in public settings—from
                          meetings to keynotes—amplifies leadership impact.
                        </p>
                      </div>
                    </div>
                  </div>
                  <div
                    tabIndex={1}
                    className="border collapse collapse-arrow border-gray-200 rounded-box bg-white"
                  >
                    <div className="text-xl font-medium collapse-title text-btnColor">
                      🎤 How to Get Better at Impromptu Speaking
                    </div>
                    <div className="collapse-content">
                      <p className="p-1">
                        Impromptu speaking means thinking on your feet and
                        expressing ideas without much prep time—it’s a valuable
                        life and work skill.
                      </p>
                      <p className="py-1">Here’s how to improve:</p>
                      <div className="py-1">
                        <p className="font-bold font-primary">
                          1. Use a simple structure
                        </p>
                        <p className="font-bold font-text">
                          Stick to{" "}
                          <b>
                            Point – Explanation – Example – Link (reiterate the
                            point)
                          </b>
                          . It keeps your answer clear even under pressure.
                        </p>
                      </div>
                      <div className="py-1">
                        <p className="font-bold font-primary">
                          2. Pause before you speak
                        </p>
                        <p className="font-bold font-text">
                          Take a breath to gather your thoughts (Inhale by
                          feeling the cool air up the nose, and exhale with
                          pursed lips). A short pause shows confidence, not
                          hesitation.
                        </p>
                      </div>
                      <div className="py-1">
                        <p className="font-bold font-primary">
                          3. Practice with prompts
                        </p>
                        <p className="font-bold font-text">
                          Use random topics or questions and give yourself 30
                          seconds to respond. It builds fluency by internalizing
                          the impromptu frameworks (PEEL).
                        </p>
                      </div>
                      <div className="py-1">
                        <p className="font-bold font-primary">
                          4. Focus on one main idea
                        </p>
                        <p className="font-bold font-text">
                          Don’t try to say everything—pick one key point and
                          support it well.
                        </p>
                      </div>
                      <div className="py-1">
                        <p className="font-bold font-primary">
                          5. Stay calm under pressure
                        </p>
                        <p className="font-bold font-text">
                          Mistakes are okay. The goal is to sound natural by not
                          interrupting the speech flow, not perfect.
                        </p>
                      </div>
                    </div>
                  </div>
                  <div
                    tabIndex={2}
                    className="border collapse collapse-arrow border-gray-200 rounded-box bg-white"
                  >
                    <div className="text-xl font-medium collapse-title text-btnColor">
                      💬 How to Prepare for a Job Interview (and Stand Out)
                    </div>
                    <div className="collapse-content">
                      <p className="p-1">
                        Doing well in an interview isn’t just about answering
                        questions—it’s about showing you’re the right fit.
                      </p>
                      <p className="py-1">Here’s how to prepare:</p>
                      <div className="py-1">
                        <p className="font-bold font-primary">
                          1. Know the job inside out
                        </p>
                        <p className="font-bold font-text">
                          Read the job description carefully. Match your skills
                          to what they’re looking for.
                        </p>
                      </div>
                      <div className="py-1">
                        <p className="font-bold font-primary">
                          2. Practice common questions
                        </p>
                        <p className="font-bold font-text">
                          Rehearse answers to “Tell me about yourself,” “What
                          are your strengths?” or “Why should we hire you?”
                        </p>
                      </div>
                      <div className="py-1">
                        <p className="font-bold font-primary">
                          3. Use the 5W 1H method
                        </p>
                        <p className="font-bold font-text">
                          Structure answers with{" "}
                          <b>
                            What (the situation), Why (importance), How
                            (solution), When (review actions at the end)
                          </b>{" "}
                          — great for behavioral/ hypothetical questions.
                        </p>
                      </div>
                      <div className="py-1">
                        <p className="font-bold font-primary">
                          4. Prepare thoughtful questions
                        </p>
                        <p className="font-bold font-text">
                          Show interest by asking about the team, growth
                          opportunities, or company values.
                        </p>
                      </div>
                      <div className="py-1">
                        <p className="font-bold font-primary">
                          5. Mind your body language
                        </p>
                        <p className="font-bold font-text">
                          Smile, make eye contact, and sit upright. Non-verbal
                          cues matter just as much as words.
                        </p>
                      </div>
                    </div>
                  </div>
                  <div
                    tabIndex={3}
                    className="border collapse collapse-arrow border-gray-200 rounded-box bg-white"
                  >
                    <div className="text-xl font-medium collapse-title text-btnColor">
                      🎯 Communication Skills Training for Managers and Team
                      Leaders
                    </div>
                    <div className="collapse-content">
                      <p className="p-1">
                        Strong communication helps leaders motivate, align, and
                        build trust with their teams.
                      </p>
                      <p className="py-1">Key areas to develop:</p>
                      <div className="py-1">
                        <p className="font-bold font-primary">
                          1. Clarity of message
                        </p>
                        <p className="font-bold font-text">
                          Leaders should exercise economy of words – always
                          strive for clarity and conciseness.
                        </p>
                      </div>
                      <div className="py-1">
                        <p className="font-bold font-primary">
                          2. Active listening
                        </p>
                        <p className="font-bold font-text">
                          Hear your team out— discover underlying concerns and
                          then respond with empathy and relevance.
                        </p>
                      </div>
                      <div className="py-1">
                        <p className="font-bold font-primary">
                          3. Giving feedback
                        </p>
                        <p className="font-bold font-text">
                          Offer constructive feedback that contains actionable
                          steps that support progress, not just correction or
                          worse, condemnation.
                        </p>
                      </div>
                      <div className="py-1">
                        <p className="font-bold font-primary">
                          4. Speaking with presence
                        </p>
                        <p className="font-bold font-text">
                          Your voice, tone, and body language should project
                          calm and confidence.
                        </p>
                      </div>
                      <div className="py-1">
                        <p className="font-bold font-primary">
                          5. Handling tough conversations
                        </p>
                        <p className="font-bold font-text">
                          Training helps leaders stay composed and fair—even
                          under pressure.
                        </p>
                      </div>
                    </div>
                  </div>
                  <div
                    tabIndex={4}
                    className="border collapse collapse-arrow border-gray-200 rounded-box bg-white"
                  >
                    <div className="text-xl font-medium collapse-title text-btnColor">
                      🚀 How to Improve Executive Presence for Career
                      Advancement
                    </div>
                    <div className="collapse-content">
                      <p className="p-1">
                        Executive presence is about how you carry yourself—your
                        communication, confidence, and credibility.
                      </p>
                      <p className="py-1">Here’s how to grow it:</p>
                      <div className="py-1">
                        <p className="font-bold font-primary">
                          1. Speak with structure
                        </p>
                        <p className="font-bold font-text">
                          Clear, organized messages reflect strong thinking.
                          E.g. Speech flow:{" "}
                          <b>Situation – Task – Action – Result</b>
                        </p>
                      </div>
                      <div className="py-1">
                        <p className="font-bold font-primary">
                          2. Control your tone and pace
                        </p>
                        <p className="font-bold font-text">
                          A calm yet firm, even voice inspires confidence.
                        </p>
                      </div>
                      <div className="py-1">
                        <p className="font-bold font-primary">
                          3. Manage reactions under stress
                        </p>
                        <p className="font-bold font-text">
                          Staying composed during pressure-cooker moments builds
                          trust.
                        </p>
                      </div>
                      <div className="py-1">
                        <p className="font-bold font-primary">
                          4. Lead with vision
                        </p>
                        <p className="font-bold font-text">
                          Use persuasive communication to align people around
                          goals and ideas, by sharing the purpose behind those
                          goals, and how they can benefit from the goals
                          achieved
                        </p>
                      </div>
                      <div className="py-1">
                        <p className="font-bold font-primary">
                          5. Get feedback on your presence
                        </p>
                        <p className="font-bold font-text">
                          Mentors or coaches can point out blind spots.
                        </p>
                      </div>
                    </div>
                  </div>

                  <div
                    tabIndex={5}
                    className="border collapse collapse-arrow border-gray-200 rounded-box bg-white"
                  >
                    <div className="text-xl font-medium collapse-title text-btnColor">
                      🧠 How to Handle Difficult Questions in Business
                      Presentations
                    </div>
                    <div className="collapse-content">
                      <p className="p-1">
                        Tough questions during a presentation can feel
                        intimidating—but they’re actually a chance to show
                        credibility and calm under pressure.
                      </p>
                      <p className="py-1">Here’s how to handle it:</p>
                      <div className="py-1">
                        <p className="font-bold font-primary">
                          1. Stay calm and listen fully
                        </p>
                        <p className="font-bold font-text">
                          Don’t interrupt. Take a breath to process before you
                          reply.
                        </p>
                      </div>
                      <div className="py-1">
                        <p className="font-bold font-primary">
                          2. Clarify if needed
                        </p>
                        <p className="font-bold font-text">
                          If the question is vague or aggressive, reframe it:
                          “Just to clarify—are you asking about…?”
                        </p>
                      </div>
                      <div className="py-1">
                        <p className="font-bold font-primary">
                          3. Acknowledge the concern
                        </p>
                        <p className="font-bold font-text">
                          A simple “That’s a valid point” shows respect and
                          professionalism despite any disagreement with the
                          argument.
                        </p>
                      </div>
                      <div className="py-1">
                        <p className="font-bold font-primary">
                          4. Answer concisely
                        </p>
                        <p className="font-bold font-text">
                          Stick to facts. If you don’t know, it’s okay to say:
                          “I’ll check on that and get back to you.”
                        </p>
                      </div>
                      <div className="py-1">
                        <p className="font-bold font-primary">
                          5. Redirect to your main message
                        </p>
                        <p className="font-bold font-text">
                          Bring the audience back to your key takeaway: “The KEY
                          point I’m trying to make is…”
                        </p>
                      </div>
                    </div>
                  </div>

                  <div
                    tabIndex={6}
                    className="border collapse collapse-arrow border-gray-200 rounded-box bg-white"
                  >
                    <div className="text-xl font-medium collapse-title text-btnColor">
                      🗣️ How to Speak Clearly and Professionally
                    </div>
                    <div className="collapse-content">
                      <p className="p-1">
                        To speak clearly and professionally means expressing
                        your ideas in a way that’s easy to follow and leaves a
                        good impression.
                      </p>
                      <p className="py-1">Here’s how to do it:</p>
                      <div className="py-1">
                        <p className="font-bold font-primary">1. Slow down</p>
                        <p className="font-bold font-text">
                          Speaking too fast can confuse your audience. Aim for a
                          natural pace. Moderate rate of speaking is about 2-3
                          words per second.
                        </p>
                      </div>
                      <div className="py-1">
                        <p className="font-bold font-primary">
                          2. Enunciate words
                        </p>
                        <p className="font-bold font-text">
                          Practice crisp, clear pronunciation—especially of key
                          terms.
                        </p>
                      </div>
                      <div className="py-1">
                        <p className="font-bold font-primary">
                          3. Trim the fillers
                        </p>
                        <p className="font-bold font-text">
                          Reduce "um", "like", and "you know". Silence is better
                          than a filler.
                        </p>
                      </div>
                      <div className="py-1">
                        <p className="font-bold font-primary">
                          4. Use simple language
                        </p>
                        <p className="font-bold font-text">
                          Big words aren’t impressive if they cause confusion.
                          Clarity wins.
                        </p>
                      </div>
                      <div className="py-1">
                        <p className="font-bold font-primary">
                          5. Practice vocal variety
                        </p>
                        <p className="font-bold font-text">
                          Change your tone and pitch to avoid sounding flat or
                          robotic.
                        </p>
                      </div>
                    </div>
                  </div>

                  <div
                    tabIndex={7}
                    className="border collapse collapse-arrow border-gray-200 rounded-box bg-white"
                  >
                    <div className="text-xl font-medium collapse-title text-btnColor">
                      🧩 How to Organize a Speech Quickly
                    </div>
                    <div className="collapse-content">
                      <p className="p-1">
                        When time is tight, a solid structure saves the day. Use
                        the tried-and-true <b>“Point, Reason, Example”</b>{" "}
                        format.
                      </p>
                      <p className="py-1">Here’s how to do it:</p>
                      <div className="py-1">
                        <p className="font-bold font-primary">
                          1. Start with your point
                        </p>
                        <p className="font-bold font-text">
                          What’s the key message or takeaway? One thing that
                          even if your audience forgets everything else BUT
                          <b>this!</b>
                        </p>
                      </div>
                      <div className="py-1">
                        <p className="font-bold font-primary">
                          2. Add your reason
                        </p>
                        <p className="font-bold font-text">
                          Why does it matter? Back it up with logic or context.
                        </p>
                      </div>
                      <div className="py-1">
                        <p className="font-bold font-primary">
                          3. Give an example
                        </p>
                        <p className="font-bold font-text">
                          Stories or real-life applications make your message
                          stick.
                        </p>
                      </div>
                      <div className="py-1">
                        <p className="font-bold font-primary">
                          4. Close with a recap
                        </p>
                        <p className="font-bold font-text">
                          Reinforce your main point and end confidently.
                        </p>
                      </div>
                    </div>
                  </div>

                  <div
                    tabIndex={8}
                    className="border collapse collapse-arrow border-gray-200 rounded-box bg-white"
                  >
                    <div className="text-xl font-medium collapse-title text-btnColor">
                      🧑💼 How to Speak Confidently in Meetings & Interviews
                    </div>
                    <div className="collapse-content">
                      <p className="p-1">
                        Speaking up in meetings is a professional skill that can
                        boost your visibility and influence.
                      </p>
                      <p className="py-1">Try this approach:</p>
                      <div className="py-1">
                        <p className="font-bold font-primary">
                          1. Prepare your points in advance
                        </p>
                        <p className="font-bold font-text">
                          Jot down key ideas or questions you want to raise,
                          with full prior knowledge of the agenda of the day.
                        </p>
                      </div>
                      <div className="py-1">
                        <p className="font-bold font-primary">
                          2. Look for open moments
                        </p>
                        <p className="font-bold font-text">
                          Chime in after someone finishes, or use phrases like
                          “To add to that…”
                        </p>
                      </div>
                      <div className="py-1">
                        <p className="font-bold font-primary">3. Start small</p>
                        <p className="font-bold font-text">
                          Comment on one idea or ask one question. You don’t
                          need to <b>dominate</b>, instead, you <b>initiate</b>{" "}
                          a new conversation!
                        </p>
                      </div>
                      <div className="py-1">
                        <p className="font-bold font-primary">
                          4. Use confident language
                        </p>
                        <p className="font-bold font-text">
                          Avoid undermining yourself with phrases like “I might
                          be wrong but…”
                        </p>
                      </div>
                      <div className="py-1">
                        <p className="font-bold font-primary">
                          5. Practice regularly
                        </p>
                        <p className="font-bold font-text">
                          The more you speak, the more natural it becomes.
                          Repetition/ Stage mileage is the killer of stage
                          fright.
                        </p>
                      </div>
                    </div>
                  </div>

                  <div
                    tabIndex={9}
                    className="border collapse collapse-arrow border-gray-200 rounded-box bg-white"
                  >
                    <div className="text-xl font-medium collapse-title text-btnColor">
                      🧠 Why Do I Fear Public Speaking?
                    </div>
                    <div className="collapse-content">
                      <p className="p-1">
                        The fear of public speaking often comes from a mix of
                        biology, past experience, and mindset.
                      </p>
                      <p className="py-1">Here’s what’s behind it:</p>
                      <div className="py-1">
                        <p className="font-bold font-primary">
                          1. Fight-or-flight response
                        </p>
                        <p className="font-bold font-text">
                          Speaking in public triggers adrenaline, which can
                          cause shaking, sweating, or brain freeze.
                        </p>
                      </div>
                      <div className="py-1">
                        <p className="font-bold font-primary">
                          2. Fear of judgment
                        </p>
                        <p className="font-bold font-text">
                          You might worry about being boring, wrong, or
                          embarrassed. Fear the spotlight treatment of
                          self-perceived inadequacy (e.g. own voice).
                        </p>
                      </div>
                      <div className="py-1">
                        <p className="font-bold font-primary">
                          3. Past negative experiences
                        </p>
                        <p className="font-bold font-text">
                          If a past presentation went badly, your brain
                          remembers.
                        </p>
                      </div>
                      <div className="py-1">
                        <p className="font-bold font-primary">
                          4. Perfectionism
                        </p>
                        <p className="font-bold font-text">
                          High self-expectations can add pressure. The higher
                          the stakes (job promotion at stake), the greater the
                          expectations.
                        </p>
                      </div>
                      <div className="py-1">
                        <p className="font-bold font-primary">
                          5. Lack of experience
                        </p>
                        <p className="font-bold font-text">
                          Like any skill, speaking gets easier with practice and
                          support.
                        </p>
                      </div>
                    </div>
                  </div>

                  <div
                    tabIndex={10}
                    className="border collapse collapse-arrow border-gray-200 rounded-box bg-white"
                  >
                    <div className="text-xl font-medium collapse-title text-btnColor">
                      💼 Public Speaking Skills for Career Success
                    </div>
                    <div className="collapse-content">
                      <p className="p-1">
                        Strong speaking skills can set you apart
                        professionally—whether you’re interviewing, managing, or
                        leading.
                      </p>
                      <p className="py-1">
                        Here’s how public speaking supports career growth:
                      </p>
                      <div className="py-1">
                        <p className="font-bold font-primary">
                          1. Enhances communication
                        </p>
                        <p className="font-bold font-text">
                          You articulate ideas more clearly and confidently.
                          This is excellent for your audience.
                        </p>
                      </div>
                      <div className="py-1">
                        <p className="font-bold font-primary">
                          2. Increases visibility
                        </p>
                        <p className="font-bold font-text">
                          Speaking up in meetings or events raises your profile,
                          and be perceived as a ready contributor.
                        </p>
                      </div>
                      <div className="py-1">
                        <p className="font-bold font-primary">
                          3. Builds leadership presence
                        </p>
                        <p className="font-bold font-text">
                          Confident speakers are often seen as potential
                          leaders.
                        </p>
                      </div>
                      <div className="py-1">
                        <p className="font-bold font-primary">
                          4. Improves persuasion
                        </p>
                        <p className="font-bold font-text">
                          You can influence others with clarity and conviction,
                          hence either open doors for you or mitigate
                          confrontation.
                        </p>
                      </div>
                      <div className="py-1">
                        <p className="font-bold font-primary">
                          5. Supports career transitions
                        </p>
                        <p className="font-bold font-text">
                          From job interviews to pitching ideas—speaking well
                          gives you an edge to land your dream job or promotion.
                        </p>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div className="hidden lg:inline w-1/3 px-5 pt-5 mb-10 border border-dashed rounded-lg">
              <Sidebar />
            </div>
          </div>
        </div>
      </section>

      <Footer />
    </>
  );
}
